import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import useEntity from "../../hooks/useEntity";
import useData from "../../hooks/useData";

import Page from "./Page";
import Card from "../layout/Card";
import BannerEditor from "../editors/BannerEditor";
import LocationsTable from "../ui/LocationsTable";

const Banner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getFromServer } = useData();

  const [bannerId, setBannerId] = useState(null);
  const [retailerId, setRetailerId] = useState(null);
  const [locations, setLocations] = useState([]);

  const {
    setEntity,
    getEntityData,
    entityData,
    setEntityData,
    emptyObject,
    saved,
  } = useEntity();

  useEffect(() => {
    setEntity("Banner");
    if (location.state?.bannerId) {
      setBannerId(location.state.bannerId);
    }
    if (location.state?.retailerId) {
      setRetailerId(location.state.retailerId);
    }
  }, []);

  useEffect(() => {
    if (bannerId) {
      loadData();
    }
  }, [bannerId]);

  useEffect(() => {
    if (!emptyObject) return;
    if (bannerId) return;

    setEntityData({ ...emptyObject, retailerId });
  }, [emptyObject]);

  useEffect(() => {
    if (saved) {
      loadData();
    }
  }, [saved]);

  const loadData = async () => {
    await getEntityData(bannerId);
    await loadLocations();
  };

  const loadLocations = async () => {
    const result = await getFromServer({
      entityName: "Location",
      filter: { bannerId },
    });

    if (result) {
      setLocations(Array.isArray(result) ? result : [result]);
    }
  };

  const handleToolbarClick = async (name) => {
    switch (name) {
      case "back":
        navigate("/retailer", { state: { retailerId } });
        break;
      case "refresh":
        await loadData();
        break;
    }
  };

  const handleLocationClick = (locationId) => {
    navigate("/location", {
      state: {
        locationId,
        bannerId,
        retailerId,
      },
    });
  };

  const handleSave = async () => {
    await loadData();
  };

  if (!entityData) return null;

  return (
    <Page
      pageName={bannerId ? entityData.name : "New Banner"}
      onToolItemClick={handleToolbarClick}
      includeToolbar
      items={[
        { name: "back", iconName: "ArrowBack" },
        { name: "refresh", iconName: "Refresh" },
      ]}
    >
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <Card title="Banner Information">
          <BannerEditor
            bannerId={bannerId}
            retailerId={retailerId}
            onSave={handleSave}
          />
        </Card>

        <Card title="Locations">
          <LocationsTable
            locations={locations}
            onLocationClick={handleLocationClick}
          />
        </Card>
      </Box>
    </Page>
  );
};

export default Banner;
